import * as S from 'pages/Institutional/style'

const Terms = () => {
  return (
    <S.Page>
      <S.Container>
        <S.Hero>
          <S.Eyebrow>Políticas RedSterna</S.Eyebrow>
          <S.Title>Termos de Uso</S.Title>
          <S.Lead>
            Estes termos definem as regras para utilização da RedSterna e ajudam
            a manter a comunidade segura, útil e respeitosa para todos os
            viajantes.
          </S.Lead>
          <S.UpdatedAt>Última atualização: 18/09/2026</S.UpdatedAt>
        </S.Hero>

        <S.Body>
          <S.Section>
            <S.SectionTitle>1. Aceitação dos termos</S.SectionTitle>
            <S.Paragraph>
              Ao acessar, criar uma conta ou utilizar a RedSterna, você declara
              que leu e concorda com estes Termos de Uso e com a Política de
              Privacidade. Se não concordar com alguma condição, não utilize a
              plataforma.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>2. O que é a RedSterna</S.SectionTitle>
            <S.Paragraph>
              A RedSterna é uma plataforma de comunidade e planejamento de
              viagens em que usuários podem criar, organizar, descobrir e
              compartilhar roteiros e experiências. Algumas áreas podem incluir
              links ou integrações com serviços de terceiros.
            </S.Paragraph>
            <S.Highlight>
              A RedSterna não substitui a verificação de informações oficiais
              sobre vistos, documentos, segurança, saúde, horários, preços,
              disponibilidade ou condições de viagem.
            </S.Highlight>
          </S.Section>

          <S.Section>
            <S.SectionTitle>3. Sua conta</S.SectionTitle>
            <S.Paragraph>
              Para criar uma conta na RedSterna, é necessário ter 18 anos ou
              mais.
            </S.Paragraph>
            <S.List>
              <li>forneça informações verdadeiras e atualizadas;</li>
              <li>mantenha suas credenciais de acesso em segurança;</li>
              <li>
                não compartilhe senhas ou permita o uso indevido da sua conta;
              </li>
              <li>avise a RedSterna caso suspeite de acesso não autorizado;</li>
              <li>
                você é responsável pelas atividades realizadas por meio da sua
                conta, salvo quando houver falha atribuível à plataforma.
              </li>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>4. Conteúdo criado pelos usuários</S.SectionTitle>
            <S.Paragraph>
              Você permanece responsável pelo conteúdo que publica e deve
              possuir os direitos ou autorizações necessários para
              compartilhá-lo.
            </S.Paragraph>
            <S.Paragraph>
              Ao publicar conteúdo na RedSterna, você autoriza a plataforma, de
              forma não exclusiva e na medida necessária à operação do serviço,
              a armazenar, processar, reproduzir tecnicamente e exibir esse
              conteúdo dentro das funcionalidades da própria RedSterna.
            </S.Paragraph>
            <S.Paragraph>
              Essa autorização não transfere a propriedade intelectual do seu
              conteúdo para a RedSterna.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>5. Condutas não permitidas</S.SectionTitle>
            <S.List>
              <li>
                publicar conteúdo ilegal, fraudulento ou que viole direitos de
                terceiros;
              </li>
              <li>praticar assédio, ameaça, discriminação ou perseguição;</li>
              <li>se passar por outra pessoa ou criar identidade enganosa;</li>
              <li>tentar acessar contas, sistemas ou dados sem autorização;</li>
              <li>
                introduzir malware, automações abusivas ou interferir na
                operação do serviço;
              </li>
              <li>
                usar a plataforma para spam ou atividades comerciais não
                autorizadas;
              </li>
              <li>
                publicar informações falsas de maneira deliberada com potencial
                de causar dano.
              </li>
            </S.List>
          </S.Section>

          <S.Section>
            <S.SectionTitle>6. Moderação e medidas de proteção</S.SectionTitle>
            <S.Paragraph>
              Conteúdos e contas podem ser analisados quando houver denúncia,
              indícios de abuso, violação destes termos ou necessidade de
              proteção da comunidade. Dependendo do caso, a RedSterna poderá
              limitar funcionalidades, remover conteúdo ou suspender acesso.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>
              7. Avaliações, favoritos e interações
            </S.SectionTitle>
            <S.Paragraph>
              Recursos como avaliações e favoritos existem para refletir a
              experiência da comunidade. O usuário não deve manipular esses
              mecanismos, criar interações artificiais ou utilizar contas
              adicionais para influenciar resultados.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>
              8. Serviços de terceiros e afiliados
            </S.SectionTitle>
            <S.Paragraph>
              A RedSterna pode direcionar usuários a fornecedores externos de
              hospedagem, passeios, transporte, conectividade e outros serviços
              de viagem. A contratação ocorre diretamente com esses terceiros e
              está sujeita aos termos, preços, políticas e condições de cada
              fornecedor.
            </S.Paragraph>
            <S.Paragraph>
              Alguns links podem gerar remuneração por indicação para a
              RedSterna, sem necessariamente alterar o preço apresentado ao
              usuário.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>
              9. Disponibilidade e mudanças na plataforma
            </S.SectionTitle>
            <S.Paragraph>
              Funcionalidades podem ser adicionadas, modificadas, suspensas ou
              descontinuadas ao longo do tempo. A RedSterna busca manter o
              serviço disponível e seguro, mas não garante funcionamento
              ininterrupto ou ausência absoluta de falhas.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>
              10. Exclusão de conta e encerramento de acesso
            </S.SectionTitle>
            <S.Paragraph>
              O usuário pode solicitar a exclusão de sua conta pelos canais
              disponibilizados pela plataforma. A RedSterna também poderá
              restringir ou encerrar contas em caso de violação relevante destes
              termos, fraude, risco à segurança ou obrigação legal.
            </S.Paragraph>
          </S.Section>

          <S.Section>
            <S.SectionTitle>11. Contato</S.SectionTitle>
            <S.Paragraph>
              Dúvidas sobre estes termos podem ser enviadas para{' '}
              <a href="mailto:contato@redsterna.com.br">
                contato@redsterna.com.br
              </a>
              .
            </S.Paragraph>
          </S.Section>
        </S.Body>
      </S.Container>
    </S.Page>
  )
}

export default Terms
